import { Edge, Node, ClusterNode, Layout } from '@swimlane/ngx-graph';
import { DataFarmType } from './dataFarmType';

// Thrown by ConfigService.UpsertRefineryConfig when the server rejects a save
// (HTTP 409) because the refinery changed since this client loaded it. Lets
// callers distinguish "someone else saved first — reload and retry" from any
// other save failure, instead of both looking like a generic error.
export class RefineryConflictError extends Error {
    constructor(message: string, public yourRevision?: number, public currentRevision?: number) {
        super(message);
        this.name = 'RefineryConflictError';
    }
}

export class DataRefineryConfig {
    guid?: string;
    id?: number;
    name: string;
    description: string;
    status: number;
    createdDateTime: Date;
    modifiedByUserId: number;
    modifiedDateTime: Date;
    // Optimistic-concurrency token — the revision this client loaded. A save
    // sends this back; the server rejects the save (409) if it no longer
    // matches what's currently on disk, instead of silently overwriting
    // another Analyst's save. Missing on responses from before this field
    // existed defaults to 0 via `?? 0` below, matching the server's default.
    revision: number;
    ingestMaps?: IngestMap[];
    /** Ingest file browser "Home" folder per data connector type ("3" = Text, "4" = Excel, …). */
    ingestHomePaths?: { [dataConnectorType: string]: string };
    nodes: Node[];
    links: Edge[];
    owner: string;
    shared: number;
    organizationId: number;
    publicShared: boolean;
    nodeWidth: number;
    nodeHeightRatio_Per: number;
    nodeHeight:number;
    nodeGearSizePX: number;
    dataWriterSize_Per:number;
    dataWriterSizePX:number;
    nodeGearSize_Per: number;
    gearPosition_X: number;
    gearPosition_Y:number;
    nodePadding_X:number;
    nodePadding_Y:number;
    nodeBorderWeight:number;
    nodeBorderStroke:number;
    nodeFontSizeTitle:number;
    nodeFontSizeSubtitle:number;
    nodeFontSizeFarmType:number;
    nodeFontSizeStatus:number;
    nodeFontSizeTitlePer:number;
    nodeFontSizeSubtitlePer:number;
    nodeFontSizeFarmTypePer:number;
    nodeFontSizeStatusPer:number;
    nodeMenuFontSizePer:number;
    menuFontSizePX:number;
    dataRefineryConfig: DataRefineryConfig;
    titlePadXPer:number;
    titlePadYPer:number;
    subTitlePadXPer:number;
    subTitlePadYPer:number;
    nodeIDPadXPer:number;
    nodeIDPadYPer:number;

    static fromJSON(data: any): DataRefineryConfig {
      //console.log(`fromJson invoked: ${data}`);
        const config: DataRefineryConfig = Object.assign(new DataRefineryConfig(), data);

        config.revision = config.revision ?? 0;
        config.modifiedDateTime = new Date(config.modifiedDateTime);
        config.createdDateTime = new Date(config.createdDateTime);
        
        const nodes: Node[] = [];
        config.nodes.forEach(node => {
            const nod = node;//Node.fromJSON(node);
            nodes.push(nod);
        });
        config.nodes = nodes;

        // Transforms
        const links: Edge[] = [];
        config.links.forEach(link => {
            //links.push(dataRefineryConfig.deserializeTransform(t));
            const lnk = link;//Node.fromJSON(node);
            links.push(lnk);
        });
        config.links = links;
        return config;
    }

    // public static deserializeTransform(t: DataTransform<any>): DataTransform<any> {
    //     switch (t.transformType) {
    //         case TransformType.activityNamer:
    //             return  ActivityNamingTransform.fromJSON(t);
    //         case TransformType.rowExtractor:
    //             return RowExtractorTransform.fromJSON(t);
    //         case TransformType.eventNamer:
    //             return EventNamerTransform.fromJSON(t);
    //         case TransformType.eventGroupNamer:
    //             return EventGroupNamerTransform.fromJSON(t);
    //         case TransformType.groupAttributo1r:
    //             return GroupAttributo1rTransform.fromJSON(t);
    //         case TransformType.columnCalc:
    //             return ColumnCalcTransform.fromJSON(t);
    //         default:
    //             throw new Error('Unsupported transform type: ' + t.transformType.toString());
    //     }
    // }
}

export interface IngestMap {
    mapName: string ;
    mapID: string;
    farmType:  DataFarmType; 
    columnMap: []

}

export class TableRefinery {
    Id:number;
    RefineryId: string ;
    RefineryName: string ;
    Owner: string ;
    Description: string ;
    Status: number;
    Shared:number;
    publicShared:boolean;
    CreatedDateTime?: Date;
    ModifiedDateTime?: Date;
    OrganizationId: number;
}
